import { publish, subscribe, unsubscribe } from 'pubsub-js';

export interface MFEContextType {
  publish: typeof publish;
  subscribe: typeof subscribe;
  unsubscribe: typeof unsubscribe;
  [key: string]: any;
}

export default class MFEContext {
  static createContext(other = {}): MFEContextType {
    return {
      publish,
      subscribe,
      unsubscribe,
      ...other,
    };
  }

  constructor() {
    throw new Error(
      'MFEContext is a static class. Use the static method "createContext".'
    );
  }
}
